import { Injectable } from '@angular/core';
import { arrayNotEmpty, isEmpty, IsEmpty, isNotEmptyObject } from 'class-validator';
import { BasicResponse } from 'src/app/core/models/basic-response.model';
import { getConnection, getCurrentUser, getFromLocal, setOnLocal } from 'src/app/core/services/functions.service';
import { QueriesService } from 'src/app/core/services/queries.service';
import { environment } from 'src/environments/environment';
import { SerEndpoint } from '../models/endpoint.model';

@Injectable({
  providedIn: 'root'
})
export class EndpointsService {

  private TABLA_PRINCIPAL: string = "ser_endpoints"

  constructor(
    private queriesService: QueriesService,
  ) { }

  async findAll(where: SerEndpoint = {}, asArray: boolean = false): Promise<BasicResponse> {
    const result = await this.queriesService.table(this.TABLA_PRINCIPAL)
      .select("TO_CHAR(id) id", "clave", "valor", "estado")
      .where({ ...where, c_emp: getConnection() })
      .orderBy("clave asc")
      .execute()
    result.data = result.data ? result.data : undefined
    if (result.success && result.data && arrayNotEmpty(result.data) && !asArray) {
      const endpoints = {}
      result.data.forEach(endpoint => {
        endpoints[endpoint.clave] = endpoint.valor
      });
      setOnLocal(environment.LOCAL_ENDPOINTS, endpoints)
      result.data = endpoints
    }
    return result
  }

  async findOne(clave: string, where: SerEndpoint = {}): Promise<BasicResponse> {
    const result = await this.queriesService.table(this.TABLA_PRINCIPAL).where({ clave, ...where }).execute()
    result.data = arrayNotEmpty(result.data) ? result.data[0] : null
    result.data.id = Number(result.data.id)
    return result
  }

  async create(value: SerEndpoint): Promise<BasicResponse> {
    const idResult = await this.queriesService.table(this.TABLA_PRINCIPAL).select("(TO_CHAR(MAX(id))+1) as id").execute()
    value.id = Number(idResult.data[0].id)
    value.c_emp = getConnection()
    const result = await this.queriesService.table(this.TABLA_PRINCIPAL).insert({ ...value, usuario_creacion: getCurrentUser().usuario_aplicativo }).execute()
    return result
  }

  async update(value: SerEndpoint, where: SerEndpoint = {}) {
    const { clave, estado, valor } = value
    where.id = Number(where.id)
    where.c_emp = getConnection()
    const result = await this.queriesService.table(this.TABLA_PRINCIPAL).update({ clave, estado, valor, usuario_modificacion: getCurrentUser().usuario_aplicativo }, where, 1).execute()
    return result
  }
}
